import { useOutlet } from "react-router-dom";

import Section from "../rows/Section";
import { SubBar } from "../base/SubBar";

import {
  GetAppBarSection,
  GetAppBarSectionUrlsByID,
} from "../../utilities/Util";

export default function AccountingLayout() {
  const appBarSection = "accounting_collapse";
  const appBarLabel = "accounting";
  const appBarPath = GetAppBarSectionUrlsByID(appBarSection, appBarLabel);

  const outlet = useOutlet();
  return (
    <>
      <h1>會計</h1>
      <Section>
        <SubBar
          pages={[
            { label: "總結", path: appBarPath },
            // { label: "列表", path: "/supplier/list" },
            { label: "新增", path: `${appBarPath}/add` },
            { label: "科目表", path: `${appBarPath}/chart` },
          ]}
        />
      </Section>
      <Section>{outlet}</Section>
    </>
  );
}
